import { Row, Col, Card, Statistic, Spin, Alert } from 'antd';
import {
	AppstoreOutlined,
	DatabaseOutlined,
	CheckCircleOutlined,
	InboxOutlined,
	ToolOutlined,
	WarningOutlined,
} from '@ant-design/icons';
import { useGetKitDashboardQuery } from '../../../redux/api/kit-staging';

const DashboardTab = () => {
	const { data, isLoading, error } = useGetKitDashboardQuery();

	if (isLoading) {
		return (
			<div className="flex justify-center items-center py-24">
				<Spin size="large" />
			</div>
		);
	}

	if (error) {
		return (
			<Alert
				type="error"
				message="Failed to load dashboard"
				description="Could not fetch staging dashboard data. Please try again later."
				showIcon
				className="my-4"
			/>
		);
	}

	const stats = data;
	const overCapacity = !!stats && stats.total_unassigned > stats.available_shelves;

	return (
		<div className="py-4">
			{overCapacity && stats && (
				<div className="mb-4 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
					<strong>Capacity Warning:</strong> There are {stats.total_unassigned}{' '}
					unassigned jobs but only {stats.available_shelves} available shelves.{' '}
					{stats.total_unassigned - stats.available_shelves} jobs will not fit.
				</div>
			)}
			<Row gutter={[16, 16]}>
				<Col xs={24} sm={12} md={8} lg={4}>
					<Card hoverable>
						<Statistic
							title="Total Staging Areas"
							value={stats?.total_staging_areas ?? 0}
							prefix={<AppstoreOutlined />}
							valueStyle={{ color: '#1890ff' }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={8} lg={4}>
					<Card hoverable>
						<Statistic
							title="Total Shelves"
							value={stats?.total_shelves ?? 0}
							prefix={<DatabaseOutlined />}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={8} lg={4}>
					<Card hoverable>
						<Statistic
							title="Assigned"
							value={stats?.total_assigned ?? 0}
							prefix={<CheckCircleOutlined />}
							valueStyle={{ color: '#52c41a' }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={8} lg={4}>
					<Card hoverable>
						<Statistic
							title="Available Shelves"
							value={stats?.available_shelves ?? 0}
							prefix={<InboxOutlined />}
							valueStyle={{ color: '#1890ff' }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={8} lg={4}>
					<Card hoverable>
						<Statistic
							title="Ready for Setup"
							value={stats?.ready_count ?? 0}
							prefix={<ToolOutlined />}
							valueStyle={{ color: '#faad14' }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={8} lg={4}>
					<Card hoverable>
						<Statistic
							title="Unassigned Jobs"
							value={stats?.total_unassigned ?? 0}
							prefix={<WarningOutlined />}
							valueStyle={{ color: '#ff4d4f' }}
						/>
						<a
							className="text-xs text-blue-600 cursor-pointer"
							onClick={() =>
								window.open('/operations/kit-staging/unassigned', '_blank')
							}
						>
							View unassigned →
						</a>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default DashboardTab;
